module.exports = __webpack_public_path__ + "img/wdzg-qrcode-app.afedd5cb.jpg";